/**
 * ImageVisual - Pure visual component for image blocks
 *
 * Renders images with URL validation for security.
 * Only allows https://, http://, and data: URLs.
 */

import type { BlockVisualProps } from '../../Types'
import './image-visual.css'

export function ImageVisual({ block }: BlockVisualProps) {
	// Type guard
	if (block.type !== 'image') return null

	const props = block.properties as {
		url?: string
		alt?: string
	}

	const { url, alt = '' } = props

	// Validate URL protocol for security
	const isValidUrl =
		url &&
		(url.startsWith('https://') || url.startsWith('http://') || url.startsWith('data:'))

	if (!isValidUrl) {
		return (
			<div className="image-visual--placeholder">
				<span style={{ color: 'var(--muted-foreground)' }}>Invalid image URL</span>
			</div>
		)
	}

	return (
		<img
			src={url}
			alt={alt}
			className="image-visual"
			style={{
				width: '100%',
				height: '100%',
				objectFit: 'contain',
			}}
		/>
	)
}
